import FetchByObjectConfig from '../Helpers/FetchByObjectConfig';

export const getConfigTransactionRequest = () => {
    const config = {
        path: 'config',
        method: 'GET',
    };
    return FetchByObjectConfig(config);
}
